/**
 * 课程卡片
 * 运营信息分类：
 * 1. 免费课：salePrice === 0
 * 2. 限时优惠：promotionType === 2
 *     到时间后显示原价
 * 3. 限量优惠：promotionType === 1
 * 4. 限量报名： promotionType === 8
 * 6. 限时报名开售后 前端判断时间 promotionType === 9
 *      到时间后显示售罄
 * 7. 售罄 status === 2
 */
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
// import Link from '../Link'
import { getSerialPrice } from '../utils'
import { COURSE_DETAIL } from '../../../config'
import CountDown from '../CountDown'
import avatarDefault from '../../common/static/avatarDefault.png'
import Link from '../../common/Link'

class CourseCard extends React.Component {

  static propTypes = {
    data: PropTypes.object.isRequired,
    topReco: PropTypes.bool,
    hasBannerLayout: PropTypes.bool,
    onClick: PropTypes.func,
    inLoc: PropTypes.string,
    serialCourse: PropTypes.object,
    showLogFuc: PropTypes.func,
  }

  static defaultProps = {
    topReco: false,
    hasBannerLayout: false,
    onClick: () => {},
    inLoc: '',
    serialCourse: null,
    showLogFuc: () => {},
  }

  static renderSaleOut() {
    return (<span className={s.saleOut}>售罄</span>)
  }

  constructor(props) {
    super(props)
    this.state = {
      inLimitTimePromotion: true, // 标记是否限时优惠到时间，需要恢复原价
      limitSalePromotionFinished: false, // 标记限时报名是否到时间，需要显示售罄
    }
    this.setLimitPromotionFinished = this.setLimitPromotionFinished.bind(this)
    this.setLimitSalePromotionFinished = this.setLimitSalePromotionFinished.bind(this)
    this.renderPromotionPrice = this.renderPromotionPrice.bind(this)
    this.renderPureOriginalPrice = this.renderPureOriginalPrice.bind(this)
    this.calcCurPromotionText = this.calcCurPromotionText.bind(this)
    this.calcPriceRender = this.calcPriceRender.bind(this)
    this.calcRootClass = this.calcRootClass.bind(this)
  }
  componentDidMount() {
    const { showLogFuc } = this.props;
    if (showLogFuc) {
      showLogFuc();
    }
  }

  setLimitPromotionFinished() {
    this.setState({ inLimitTimePromotion: false })
  }

  setLimitSalePromotionFinished() {
    this.setState({ limitSalePromotionFinished: true })
  }

  calcCurPromotionText(data) {
    // 限时优惠
    const now = new Date().getTime()
    if (data.promotionType === 2 && this.state.inLimitTimePromotion
      && data.saleEndTime > now) {
      return (
        <p>距结束:<CountDown
          deadTime={data.saleEndTime}
          callback={this.setLimitPromotionFinished}
        /></p>)
    }
    // 限量优惠 & 限量报名
    if ((data.promotionType === 1 || data.promotionType === 8)
    && data.limitNum > data.courseSaleNum) {
      return (<p>{`限量${data.limitNum}人`}</p>)
    }

    // 限时报名
    if (data.promotionType === 9 && !this.state.limitSalePromotionFinished &&
      data.registrationDeadline > now) {
      if (now > data.saleStartTime) {
        return (
          <p>距结束:<CountDown
            deadTime={data.registrationDeadline}
            callback={this.setLimitSalePromotionFinished}
          /></p>)
      }
      return (
        <p>距开售:<CountDown
          deadTime={data.courseStartTime}
          callback={this.setLimitSalePromotionFinished}
        /></p>)
    }

    return (<p>&nbsp;</p>)
  }

  calcRootClass() {
    const { hasBannerLayout, topReco } = this.props
    return `${s.root} ${hasBannerLayout ? s.lay3 : s.lay4} ${topReco ? s.topReco : ''}`
  }

  calcPriceRender() {
    const { data, serialCourse } = this.props
    const { status, courseSalePrice, courseOriginalPrice, promotionType } = data || {};
    // 组合卡片系列课程
    if (serialCourse) {
      return this.renderPureOriginalPrice()
    }

    // 售罄
    if (status !== 1 || this.state.limitSalePromotionFinished) {
      return CourseCard.renderSaleOut()
    }

    // 原价无优惠 || 限时优惠到时间了
    if (!courseSalePrice ||
        courseOriginalPrice === courseSalePrice ||
        (promotionType === 2 && !this.state.inLimitTimePromotion)) {
      return this.renderPureOriginalPrice()
    }

    // 显示优惠价格
    return this.renderPromotionPrice()
  }

  renderPureOriginalPrice() {
    const { data, serialCourse } = this.props
    const { minPrice, maxPrice } = serialCourse || {};
    const { courseOriginalPrice, courseSalePrice } = data || {};
    if (courseOriginalPrice || (maxPrice && maxPrice !== 0)) {
      return (
        <span className={s.curPrice}>
          <span>￥</span>{serialCourse ? getSerialPrice(minPrice, maxPrice) : courseSalePrice}
        </span>)
    }
    return (<span className={s.curPrice}>免费</span>)
  }

  renderPromotionPrice() {
    const { data } = this.props
    return (
      <span className={s.price}>
        <span className={s.original}>￥{data.courseOriginalPrice}</span>
        {data.courseSalePrice === 0 ?
          <span className={s.curPrice}>免费</span> :
          <span className={s.curPrice}>
            <span>￥</span>{data.courseSalePrice}
          </span>
        }
      </span>
    )
  }

  render() {
    const { data, onClick, inLoc, serialCourse } = this.props
    // 普通课，限时优惠，限量优惠，限时报名，限量报名 隐藏数量
    const { id, categoryName, serialType, courseCount, title, saleNum } = serialCourse || {};
    const hide = serialCourse ? serialCourse.hideNum : data.hideNum && (!data.promotionType ||
      [1, 2, 8, 9].indexOf(data.promotionType) > -1)
    const teacherList = serialCourse ? serialCourse.teacherList : data.teacherList;

    return (
      <Link
        to={serialCourse ? `/serial/${id}` : `${COURSE_DETAIL}${data.id}`}
        extraParams={inLoc ? { inLoc } : null}
        target={'_blank'}
        rel={'noopener noreferrer'}
        className={this.calcRootClass()}
        onClick={onClick}
      >
        <span className={s.category}>
          {serialCourse ? categoryName : data.categoryName}
        </span>
        <h1 className={s.title}>{serialCourse ? title : data.courseTitle}</h1>
        {serialCourse ? (
          <div className={s.serialCourse}>
            {serialType}&nbsp;/&nbsp;共&nbsp;{courseCount}&nbsp;门课
          </div>
        ) : (
          <div className={s.time}>时间：{ data.courseTime || '随到随学'} {data.courseSalePrice > 20 && <span><ins>|</ins> {data.lessonNum}课时</span>}</div>
        )}
        <div className={s.teachers}>
          {!teacherList || teacherList.length === 0 ? null :
            teacherList.slice(0, 3).map(teacher => (
              <div key={`coursecard-teacher-${data.id ? data.id : id}-${teacher.name}`} className={s.teacher}>
                <img
                  className={s.avatar}
                  src={teacher.imgUrl || avatarDefault}
                  alt={teacher.name}
                />
                <span>{teacher.name}</span>
              </div>
            ))}
        </div>
        <div className={s.saleInfo}>
          <div className={s.left}>
            <span className={`${s.promotion} ${hide ? s.hideNum : ''}`}>{this.calcCurPromotionText(data || {})}</span>
            {hide ? null :
            <span className={s.saleNum}>已有{serialCourse ? saleNum : data.courseSaleNum}人购买</span>}
          </div>
          <div className={s.right}>
            {this.calcPriceRender()}
          </div>
        </div>
      </Link>
    );
  }
}

export default withStyles(s)(CourseCard);



// WEBPACK FOOTER //
// ./src/components/common/CourseCard/index.js